import { createRouter, createWebHashHistory, RouteRecordRaw, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import page from '../views/page.vue'
import layout from '../views/layout/index.vue'
import f10Index from '../views/f10/index.vue'
import f10IndexHk from '../views/f10Hk/index.vue'
import f10IndexUs from '../views/f10Us/index.vue'
import upAnalysis from '../views/upAnalysis.vue'
import hot from '../views/hot.vue'
import store from '@/store'

const routesarr = [
  // {
  //   // 操作手册
  //   path: '/page',
  //   name: 'name',
  //   redirect: '/home'
  // },
  // ---------------------此处操作手册路由必须为第0个，如修改了顺序，需要修改store里的FRESH_MYROUTES方法
  {
    // 操作手册
    path: '/page',
    name: 'Layout',
    component: layout,
    children: [
    ]
  },
  {
    path: '/f10',
    name: 'f10laout',
    component: f10Index
  },
  {
    path: '/f10Hk',
    name: 'f10laout-hk',
    component: f10IndexHk
  },
  {
    path: '/f10Us',
    name: 'f10laout-Us',
    component: f10IndexUs
  },
  {
    path: '/hot',
    name: 'hot',
    component: hot
  },
  {
    path: '/lowversion',
    name: 'lowversion',
    component: () => import(/* webpackChunkName: "lowversion" */ '../views/lowversion.vue')
  },
  {
    // 涨停分析
    path: '/upAnalysis',
    name: 'upAnalysis',
    component: upAnalysis
  },
  {
    // 问董秘
    path: '/asking',
    name: 'asking',
    component: () => import(/* webpackChunkName: "asking" */ '../views/asking/index.vue')
  },
  {
    path: '/askingdetail',
    name: 'askingdetail',
    component: () => import(/* webpackChunkName: "askingdetail" */ '../views/asking/detail.vue')
  },
  {
    path: '/askingdelist',
    name: 'askingdelist',
    component: () => import(/* webpackChunkName: "askingdetail" */ '../views/asking/list.vue')
  },
  {
    path: '/top10',
    name: 'top10',
    component: () => import(/* webpackChunkName: "top10" */ '../components/asktheSecretary/top10.vue')
  },
  {
    // 股池 (已废弃)
    path: '/stockpool',
    name: 'stockpool',
    component: () => import(/* webpackChunkName: "stockpool" */ '../views/stockpool/index.vue')
  },
  {
    // 九方学堂
    path: '/school',
    name: 'jfschool',
    component: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/layout.vue'),
    children: [
      {
        path: '/excellentcourse',
        name: 'excellentcourse',
        layout: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/layout.vue'),
        component: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/excellentcourse.vue'),
        meta: {
          title: '精品课程'
        }
      },
      {
        path: '/selectedtopics',
        name: 'selectedtopics',
        layout: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/layout.vue'),
        component: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/selectedtopics.vue'),
        meta: {
          title: '精选专题'
        }
      },
      {
        path: '/specialcourse',
        name: 'specialcourse',
        layout: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/layout.vue'),
        component: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/specialcourse.vue'),
        meta: {
          title: '专题课程',
          hide: true,
          pname: 'selectedtopics'
        }
      },
      {
        path: '/allcourse',
        name: 'allcourse',
        layout: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/layout.vue'),
        component: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/allcourse.vue'),
        meta: {
          title: '全部课程'
        }
      },
      {
        path: '/coursedetail',
        name: 'coursedetail',
        layout: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/layout.vue'),
        component: () => import(/* webpackChunkName: "jfschool" */ '../views/jfschool/coursedetail.vue'),
        meta: {
          title: '课程详情',
          hide: true,
          pname: 'allcourse'
        }
      }
    ]
  },
  {
    path: '/tokenpage',
    name: 'tokenpage',
    component: () => import(/* webpackChunkName: "test" */ '../views/test/tokenrequest.vue')
  },
  // 个股笔记
  {
    path: '/stocknotes/index',
    name: 'stocknotes',
    component: () => import(/* webpackChunkName: "stocknotes" */ '../views/stocknotes/index.vue')
  },
  {
    path: '/stocknotes/kline',
    name: 'klinenotes',
    component: () => import(/* webpackChunkName: "stocknotes" */ '../views/stocknotes/kline.vue')
  },
  // 条件选股
  {
    path: '/conditionstock',
    name: 'conditionstock',
    component: () => import(/* webpackChunkName: "conditionstock" */ '../views/conditionstock/index.vue')
  },
  {
    path: '/pageAll',
    name: 'pageAll',
    component: () => import(/* webpackChunkName: "pageAll" */ '../views/pageAll/index.vue')

  }
]
// const operationroutes = sessionStorage.getItem('operationroutes') ? JSON.parse(sessionStorage.getItem('operationroutes') || '[]') : []

// if (operationroutes && operationroutes.length) {
//   routesarr[1].children = JSON.parse(sessionStorage.getItem('operationroutes') || '[]')
// }
const operationroutes: any = store.state.myroutes
// const operationroutes: any = JSON.parse(localStorage.getItem('vuex') || '{}').myroutes
if (operationroutes.length) {
  routesarr[1].children = operationroutes
}
const routes: Array<any> = routesarr

let router = createRouter({
  history: createWebHashHistory(),
  routes
})
if ((location.href).indexOf('routingmode=history') > -1) {
  router = createRouter({
    history: createWebHistory(),
    routes
  })
}
export default router
